import React, {
  useState, useEffect, forwardRef, useImperativeHandle,
} from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { animated, useSpring } from '@react-spring/web';
import styles from './right-modal.module.scss';

const ModalStandalone = forwardRef(({
  children,
  hideCloseButton = true,
  domNode = 'modal',
  handleClose,
  zIndex = 1000,
}, ref) => {
  const modalRoot = document.getElementById(domNode);
  const [open, setOpen] = useState(false);
  const [toggleAnimation, setToggleAnimation] = useState(false);

  useImperativeHandle(ref, () => ({
    toggle: () => setOpen((state) => !state),
    open: () => setOpen(true),
    close: (e) => {
      setToggleAnimation(false);
      if (handleClose) handleClose(e);
    },
  }));

  function toggle() { setOpen((state) => !state); }

  function close() {
    setToggleAnimation(false);
  }

  const spring = useSpring({
    opacity: toggleAnimation ? 1 : 0,
    transform: toggleAnimation ? 'translate(0, 0)' : 'translate(100px, 0)',
    onRest: (state) => {
      if (state.value.opacity === 0) toggle();
    },
  });

  // HANDLE CLOSE MODAL WHEN CLICK OUTSITE
  // EXCEPT IT TARGET ELEMENT HAS ATTRIBUTE
  // data-close-modal='false'
  useEffect(() => {
    const root = document.getElementById('root');
    const closeModal = (e) => {
      if (open && !e.target.closest("[data-close-modal='false']")) {
        setToggleAnimation(false);
        if (handleClose) handleClose(e);
      }
    };
    root.addEventListener('click', closeModal);
    return () => {
      root.removeEventListener('click', closeModal);
    };
  }, [open]);

  useEffect(() => {
    if (!ref) console.error('ModalStandalone components need require a ref');
  }, [ref]);

  useEffect(() => {
    if (!modalRoot) {
      console.error(`Can't find the dom element (#${domNode}) where this modal should be mount \nYou should add a div with id : "${domNode}" to public/index.html
     `);
    }
  }, [modalRoot, domNode]);

  useEffect(() => {
    if (open) {
      setToggleAnimation(true);
    }
    // if (open === false && handleClose) handleClose();
  }, [open]);

  return (
    <>
      { modalRoot
        && <>
          {createPortal(
            <>
              {(ref && open)
                && <>
                  <animated.div
                    style={{ ...spring, zIndex: zIndex || 1000 }}
                    className={styles.modal}
                  >
                     {children}
                     {!hideCloseButton && <button onClick={close}>Fermer</button>}
                  </animated.div>
                </>

              }
            </>,
            modalRoot,
          )}
        </>
      }
    </>
  );
});

ModalStandalone.propTypes = {
  domNode: PropTypes.string,
};

export default ModalStandalone;
